import type {
	DataSourceApi,
	InfiniteTableApi,
} from "@infinite-table/infinite-react";
import type { News } from "epsm-api-types/models";
import { useEffect, useState } from "react";

export function useScrollIntoSavedPosition(ticker: string) {
	const [apis, onReady] = useState<{
		api: InfiniteTableApi<News>;
		dataSourceApi: DataSourceApi<News>;
	}>();

	const [firstRowIndex, setFirstRowIndex] = useState<Record<string, number>>(
		{},
	);

	// biome-ignore lint/correctness/useExhaustiveDependencies: correct deps array
	useEffect(() => {
		const scrollPosition = firstRowIndex[ticker] || 0;

		apis?.api.scrollRowIntoView(scrollPosition - 3);

		return () => {
			const newPosition =
				apis?.api.getVerticalRenderRange().renderEndIndex || 0;

			setFirstRowIndex((prev) => ({
				...prev,
				[ticker]: newPosition,
			}));
		};
	}, [ticker]);

	return { onReady };
}
